import { store } from "@/store/store";
import { centros_servicios } from "@/shared/dtos/centros_servicios";
import {
  VuexModule,
  Mutation,
  getModule,
  Module,
  Action,
} from "vuex-module-decorators";
import { ssmHttpService } from "@/shared/services/http-service";
import { API } from "@/shared/api";

@Module({
  namespaced: true,
  name: "centros_serviciosModule",
  store,
  dynamic: true,
})
class centros_serviciosModule extends VuexModule {
  public centros_servicios: centros_servicios[] = [];
  public centro_servicio: centros_servicios = new centros_servicios();

  @Action({ commit: "onGetcentros_servicios" })
  public async getcentros_servicios() {
    return await ssmHttpService.get(API.centros_servicios);
  }

  @Action({ commit: "onGetcentro_servicio" })
  public async getcentro_servicio(id: any) {
    return await ssmHttpService.get(API.centros_servicios + "/" + id);
  }

  @Action
  public async guardarcentro_servicio(item: centros_servicios) {
    return await ssmHttpService.post(
      API.centros_servicios,
      item.toJson([
        "created_at_utc",
        "updated_at_utc",
        "created_by_user_id",
        "updated_by_user_id",
      ])
    );
  }

  @Action
  public async modificarcentro_servicio(item: centros_servicios) {
    return await ssmHttpService.put(
      API.centros_servicios + "/" + item.id,
      item.toJson([
        "created_at_utc",
        "updated_at_utc",
        "created_by_user_id",
        "updated_by_user_id",
      ])
    );
  }

  @Action
  public async eliminarcentro_servicio(item: centros_servicios) {
    return await ssmHttpService.delete(
      API.centros_servicios + "/" + item.id,
      null,
      false
    );
  }

  @Mutation
  public onGetcentros_servicios(res: centros_servicios[]) {
    this.centros_servicios = res
      ? res.map((x) => new centros_servicios(x))
      : [];
  }

  @Mutation
  public onGetcentro_servicio(res: centros_servicios) {
    this.centro_servicio = new centros_servicios(res);
  }
}

export default getModule(centros_serviciosModule);
